import Footer from "./../../Footer";
import * as React from "react";
import {GatewayProvider} from "react-gateway";
import {useTranslation} from "react-i18next";
import {FaLock} from "react-icons/fa";
import styled from "styled-components";
import {isCart, useUnsafeCartContext} from "../../cart/CartContextProvider/CartContextProvider";
import ShoppingCart, {TotallyEmptyCart} from "../../cart/ShoppingCart/ShoppingCart";
import Modal from "./Modal";

interface ICartWrapperProps {
  isCartVisible: boolean;
  closeFunction: () => void;
}

const CartWrapperModal: React.FC<ICartWrapperProps> = (props) => {
  const context = useUnsafeCartContext();
  const {t} = useTranslation("cart");

  if (!context) {
    return null;
  }

  const Header: React.FC = () => {
    const onLogoClicked = () => {
      if (isCart(context)) {
        context.setIsIntoCheckout(false);
      }
      props.closeFunction();
    };

    return (
      <Wrapper>
        <Logo className={"svg-main-logo-both"} onClick={onLogoClicked} />
        <SecureOrder>
          <FaLock />
          <span>&#160;{t("Sichere Bestellung")}</span>
        </SecureOrder>
      </Wrapper>
    );
  };

  return (
    <Modal fullScreen={true} isVisible={context.isCartVisible}>
      <div>
        <Header />
        {isCart(context) ? (
          <GatewayProvider>
            <ShoppingCart />
          </GatewayProvider>
        ) : (
          <TotallyEmptyCart />
        )}
      </div>
      <Footer />
    </Modal>
  );
};

export default CartWrapperModal;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`;
const Logo = styled.div`
  cursor: pointer;
`;
const SecureOrder = styled.div`
  display: flex;
  align-items: center;
  color: #888;
`;
